module.exports = __webpack_public_path__ + "img/question-solid.65845817.svg";